import { Children, cloneElement } from "react";
import { useRecoilValue } from "recoil";
import { userState } from "../store/UserState";
import { accessControl, ROLE_ADMIN, ROLE_OWNER } from "../utils/AccessControl";

function RoleControl({subject, verb, ok, ng, children}) {
  let {role} = useRecoilValue(userState);
  if (role === ROLE_OWNER) role = ROLE_ADMIN;
  if (accessControl(subject, verb, role)) {
    if (ok) {
      if (typeof ok === 'function') {
        return ok();
      } else {
        return ok;
      }
    } else {
      return children;
    }
  } else {
    if (ng) {
      if (typeof ng === 'function') {
        return ng();
      } else {
        return ng;
      }
    } else {
      return Children.map(children, child => cloneElement(child, {disabled: true})) || null;
    }
  }
}

export default RoleControl;
